<template>
  <div class="home-ownership-page">
    <!-- Header Section -->
    <AppHeader 
      header-text="Drivers in your state can save up to $600/year"
      button-text="FREE CALL"
    />

    <!-- Progress Bar -->
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>

    <!-- Navigation -->
    <div class="navigation">
      <div class="container">
        <button class="back-btn" @click="goBack">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Previous Question
        </button>
      </div>
    </div>

    <!-- Home Ownership Section -->
    <section class="home-ownership-section">
      <div class="container">
        <div class="ownership-content">
          <PageTitle title="Home Ownership" />
          
          <div class="ownership-options">
            <button 
              :class="['ownership-btn', { 'selected': selectedOwnership === 'own' }]"
              @click="selectOwnership('own')"
            >
              YES, I OWN MY HOME
            </button>
            <button 
              :class="['ownership-btn', { 'selected': selectedOwnership === 'rent' }]"
              @click="selectOwnership('rent')"
            >
              NO, I DO NOT OWN MY HOME
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer Links -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import PageTitle from '@/components/PageTitle.vue'
import { submitDataAndLog } from '@/utils/localStorage'

export default {
  name: 'HomeOwnershipPage',
  components: {
    AppHeader,
    AppFooter,
    PageTitle
  },
  data() {
    return {
      userQuoteData: null,
      selectedOwnership: null
    }
  },
  mounted() {
    this.loadUserData()
  },
  methods: {
    loadUserData() {
      const storedData = localStorage.getItem('quoteData')
      if (storedData) {
        try {
          this.userQuoteData = JSON.parse(storedData)
          // 检查是否有地址信息
          if (!this.userQuoteData.address) {
            // 如果没有地址信息，跳转回current-address页面
            this.$router.push('/current-address')
            return
          }
          // 加载之前选择的房屋所有权（如果有的话）
          if (this.userQuoteData.home_ownership !== undefined) {
            this.selectedOwnership = this.userQuoteData.home_ownership
          }
        } catch (error) {
          console.error('Error parsing stored data:', error)
          this.$router.push('/')
        }
      } else {
        // 如果没有数据，跳转回首页
        this.$router.push('/')
      }
    },
    
    saveUserData() {
      localStorage.setItem('quoteData', JSON.stringify(this.userQuoteData))
    },
    
    async selectOwnership(ownership) {
      this.selectedOwnership = ownership
      
      // 更新用户数据
      this.userQuoteData.home_ownership = ownership
      this.saveUserData()
      
      console.log('Selected home ownership:', ownership)
      
      // 根据选择跳转到不同页面
      // 提交数据并记录页面提交事件
      await submitDataAndLog('homeownership')
      
      if (ownership === 'own') {
        // 如果选择拥有房屋，跳转到Bundle Home页面
        this.$router.push('/bundle-home')
      } else {
        // 如果选择不拥有房屋，跳转到Email Address页面
        this.$router.push('/email-address')
      }
    },
    
    goBack() {
      this.$router.push('/current-address')
    }
  }
}
</script>

<style scoped>
/* Page Layout */
.home-ownership-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Navigation */
.navigation {
  padding: 1rem 0;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: #999;
  font-size: 0.9rem;
  cursor: pointer;
  transition: color 0.3s ease;
}

.back-btn:hover {
  color: #666;
}

/* Home Ownership Section */
.home-ownership-section {
  padding: 4rem 0;
  background: #fff;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ownership-content {
  text-align: center;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 2rem;
}

.ownership-options {
  display: flex;
  gap: 2rem;
  justify-content: center;
  margin-top: 2rem;
}

.ownership-btn {
  padding: 1.5rem 2rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  color: #007bff;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 250px;
  text-align: center;
}

.ownership-btn:hover {
  border-color: #007bff;
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.15);
}

.ownership-btn.selected {
  border-color: #007bff;
  background: #007bff;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .ownership-content {
    padding: 0 1rem;
  }

  .ownership-options {
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
  }

  .ownership-btn {
    width: 100%;
    max-width: 350px;
    padding: 1.2rem 1.5rem;
    font-size: 1rem;
    min-width: unset;
  }
}

@media (max-width: 480px) {
  .ownership-content {
    padding: 0 0.5rem;
  }

  .ownership-btn {
    max-width: 300px;
    padding: 1rem 1rem;
    font-size: 0.9rem;
  }

  .ownership-options {
    gap: 1rem;
  }
}
</style>
